import BaseAPI from "../api";
import { AxiosResponse } from 'axios';

const path: string = "/examination-calendar";

export class ExaminationCalendarApi extends BaseAPI {
  static list(query: any): Promise<any> {
    return this.api.get(`${path}/list`, {
      params: { ...query },
    });
  }
  static post(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }
  static upload(body: any): Promise<AxiosResponse> {
    return this.api.post(`${path}/upload-files`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  static patch(body: any, id: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }
  static findById(id: any): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }
  static delete(id: any): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }
  static download(id: any): Promise<any> {
    return this.api.get(`${path}/${id}/download`, { responseType: 'arraybuffer' });
  }
  static downloadFile(id_examination_calendar_file : number): Promise<AxiosResponse> {
    return this.api.get(`${path}/${id_examination_calendar_file}/download-file`, { responseType: 'blob' });
  }
}
